import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";

import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import BlackduckBinaryAnalysisMappingForm from "./BlackduckBinaryAnalysisMappingForm";



const BlackduckBinaryAnalysisCredentialsForm = (props, ref) => {
    const fields = [
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            rules: [urlRegexValidator],
            required: true,
        },
        {
            name: "username",
            label: "Username",
            required: true
        },
        {
            name: "password",
            label: "Password",
            type: FieldTypes.PASSWORD,
            required: true
        }
    ]
    return (
        <GenericPullCredentialsForm
        {...props}
        ref={ref}
        fields={fields}
        MappingForm={BlackduckBinaryAnalysisMappingForm}
        />
    )
};

export default forwardRef(BlackduckBinaryAnalysisCredentialsForm)